import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/client';
import { State } from 'src/api/types';

interface StatesState {
  items: State[],
  error: string | null,
  loading: boolean,
  loaded: boolean
}

const initialState: StatesState = {
  items: [],
  error: null,
  loading: false,
  loaded: false
}

export const fetchStates = createAsyncThunk('states/fetchStates',
  async (_, {rejectWithValue}) => {
    try {
      return apiClient.getStates();
    }
    catch (error) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue('Unknown type of error occurred');
    }
  }
)

const statesSlice = createSlice({
  name: 'states',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchStates.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchStates.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload;
      state.loaded = true;
    })
    .addCase(fetchStates.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload as string;
    })
  }
})

export default statesSlice.reducer;